(() => {
  const init = () => {
    document.querySelectorAll('.template-product .evences-media-swipe').forEach((track) => {
      const slides = Array.from(track.children).filter(el => el.offsetParent !== null);
      if (slides.length <= 1) return;

      // Dots
      let dots = track.parentElement.querySelector('.evences-dots');
      if (!dots) {
        dots = document.createElement('div');
        dots.className = 'evences-dots';
        track.parentElement.appendChild(dots);
      }
      dots.innerHTML = '';
      slides.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'evences-dot' + (i === 0 ? ' is-active' : '');
        b.addEventListener('click', () => {
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        });
        dots.appendChild(b);
      });

      const setActive = () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        Array.from(dots.children).forEach((d, idx) => d.classList.toggle('is-active', idx === i));
      };

      track.addEventListener('scroll', () => window.requestAnimationFrame(setActive), { passive: true });
      window.addEventListener('resize', setActive);
    });
  };

  document.addEventListener('DOMContentLoaded', init);
})();
